import { render, staticRenderFns } from "./SubscriptionExpiredModal.vue?vue&type=template&id=006800d6&scoped=true&"
import script from "./SubscriptionExpiredModal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionExpiredModal.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionExpiredModal.vue?vue&type=style&index=0&id=006800d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006800d6",
  null
  
)

export default component.exports